import React from 'react';
import {
  ControlElement,
  JsonFormsRendererRegistryEntry,
  JsonSchema,
  RendererProps,
  UISchemaElement,
  WithClassname,
} from '@jsonforms/core';
import { twJoin } from 'tailwind-merge';
import { edtfMapper } from '../edtfMapper';
import { EDTF_TYPES } from '@shared/types/ImagingSpecialist';
import { useJsonForms } from '@jsonforms/react';

type DisplayControlRendererProps = RendererProps &
  WithClassname & { dark?: boolean; schema: JsonSchema };

const DisplayControlRenderer: React.FC<DisplayControlRendererProps> = ({
  schema,
  uischema,
  dark,
}) => {
  const ctx = useJsonForms();
  const data = ctx.core?.data;

  const controlElement = uischema as ControlElement;
  const id = controlElement.scope?.split('/').pop() || '';
  const format = schema.properties?.[id]?.format as EDTF_TYPES;

  const value = data?.[id];

  return (
    <div>
      <div
        className={twJoin(
          'border-brightGray mb-3 flex gap-1 rounded-md border p-[12px]',
          dark ? 'bg-pageBackgroundDark border-chineseBlack text-white' : 'bg-[#F6F9FF]'
        )}
      >
        <div className="text-1824 qc-form-label font-medium capitalize">
          {typeof controlElement.label === 'string' ? controlElement.label : id}
        </div>
      </div>
      <div
        className={twJoin(
          'text-1624 rounded-md border p-[12px] font-medium',
          dark ? 'bg-arsenic border-chineseBlack text-white' : 'border-brightGray'
        )}
      >
        {edtfMapper({
          type: format,
          value: value,
        })}
      </div>
    </div>
  );
};

export const createDisplayControlRenderer = (dark?: boolean): JsonFormsRendererRegistryEntry => {
  return {
    tester: (uischema: UISchemaElement) => (uischema.type === 'Control' ? 2 : -1),
    renderer: (props: RendererProps & WithClassname) => {
      return (
        <DisplayControlRenderer
          {...props}
          dark={dark}
        />
      );
    },
  };
};
